var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLang(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_1559)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_33_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9166 23.9911C12.6318 23.9914 13.2122 24.5719 13.2126 25.2871C13.2126 26.0027 12.6321 26.5828 11.9166 26.5831H-1.66103C-2.37679 26.5831 -2.95703 26.0029 -2.95703 25.2871C-2.9566 24.5717 -2.37653 23.9911 -1.66103 23.9911H11.9166ZM20.9683 12.6781C21.6837 12.6786 22.2643 13.2586 22.2643 13.9741C22.2641 14.6894 21.6836 15.2697 20.9683 15.2701H-1.66103C-2.37663 15.2701 -2.95676 14.6897 -2.95703 13.9741C-2.95703 13.2584 -2.37679 12.6781 -1.66103 12.6781H20.9683ZM30.0184 1.36343C30.7342 1.36343 31.3144 1.94367 31.3144 2.65943C31.3144 3.3752 30.7342 3.95543 30.0184 3.95543H-1.66103C-2.37679 3.95543 -2.95703 3.3752 -2.95703 2.65943C-2.95703 1.94367 -2.37679 1.36343 -1.66103 1.36343H30.0184Z",
    fill: "#1D1D1D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_1559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_33_1559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.56,
    height: 34.56,
    fill: "white",
    transform: "translate(-3.09961 -3.10001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.eb25539e3636e7c14d93694442181b43.svg";
export { ForwardRef as ReactComponent };